import React, {useState} from 'react'
import { useHistory } from 'react-router-dom';
import {CoursesTypes, useCoursesState} from "../../contexts/courses";
import {getCookie, pushDataLayer, sessionStore} from "../../services/utils";
import DiscountCode from "../DiscountCode/DiscountCode";
import FinalPrice from "../CheckoutComponents/FinalPrice";
import ButtonDropdown from "../AppButton/ButtonDropdown";
import Button from "../AppButton/Button";
import {GlobalTypes, useGlobalState} from "../../contexts/global";
import {CourseType, PayByType, ProfileType} from "../../services/types";
import {orderCourses} from "../../moduls/courses";
import {routesURLs} from "../../Routes";
import BasketItem from "../Basket/BasketItem";
import "./ModalBasket.scss";
import { useQuery } from 'react-query';
import { getProfile } from '../../moduls/profile';
import { format, parseISO } from 'date-fns';
import { cs } from 'date-fns/locale';

const ModalBasket: React.FC<{ closeModal: () => void }> = ({ closeModal }) => {
    const [price, setPrice] = useState<number | null>(null);
    const { state, dispatch } = useGlobalState();
    const { state: coursesState, dispatch: dispatchCourses} = useCoursesState();
    const history = useHistory();

    const { data: profile } = useQuery<ProfileType>('profile', getProfile, {
        enabled: !!getCookie('jid'),
        staleTime: Infinity,
    });

    const coursesInBasket = coursesState.savedOnlineCourses.length + coursesState.savedPersonalCourses.length + coursesState.savedOnlineMockExamCourses.length + coursesState.savedPersonalTests.length;

    function removeCourse(id: number, courseType: CourseType) {
        dispatchCourses({ type: CoursesTypes.RemoveSavedCourse, id, courseType });
    }

    function removeAllItem() {
        coursesState.savedOnlineCourses.map((course) => (
            removeCourse(course.id, 'online')
        ));

        coursesState.savedPersonalCourses.map((course) => (
            removeCourse(course.id, 'personal')
        ));

        coursesState.savedOnlineMockExamCourses.map((course) => (
            removeCourse(course.id, 'online-mock-exam')
        ));

        coursesState.savedPersonalTests.map((course) => (
            removeCourse(course.id, 'personalTest')
        ));
    }

    const manageOrder = (pay_by: PayByType) => {
        dispatch({ type: GlobalTypes.ToggleLoader, loader: 'manageOrder' });
        orderCourses(
            {
                onsite_courses: coursesState.savedPersonalCourses.map((course) => ({
                    id: course.id,
                    student_name: course.student_name,
                })),
                online_courses: coursesState.savedOnlineCourses.map((course, index) => ({
                    id: course.id,
                    price_package_id: course.price_package_id,
                    lesson_ids: course.lesson_ids,
                    discount_code:
                        index === 0 && state.discount.one_time && state.discount.code
                            ? state.discount.code
                            : undefined,
                })),
                online_mock_exam_courses: coursesState.savedOnlineMockExamCourses.map((course) => ({
                    id: course.id,
                    price_package_id: course.price_package_id,
                    lesson_ids: course.lesson_ids,
                })),
                onsite_tests: coursesState.savedPersonalTests.map((course) => ({
                    id: course.id,
                    student_name: course.student_name,
                })),
                discount_code:
                    state.discount.one_time === 0 && state.discount.code ? state.discount.code : undefined,
            },
            pay_by
        )
            .then((res) => {
                const transactionProducts: object[] = [];
                coursesState.savedPersonalCourses.forEach(course => {
                    transactionProducts.push({
                        'item_id': 'onsite_' + course.id,
                        'item_name': course.course,
                        'price': course.term.price.toString(),
                        'quantity': 1,
                        'item_category': 'Přípravné kurzy',
                        'item_category2': '9. TŘÍDA',
                        'item_variant': 'on-site'
                    });
                });
                coursesState.savedOnlineCourses.forEach(course => {
                    transactionProducts.push({
                        'item_id': 'online_' + course.id,
                        'item_name': course.course.name,
                        'price': course.course.price.toString(),
                        'quantity': 1,
                        'item_category': 'Přípravné kurzy',
                        'item_category2': course.course.classLesson,
                        'item_category3': course.course.subject,
                        'item_variant': 'on-line'
                    });
                })
                coursesState.savedOnlineMockExamCourses.forEach(course => {
                    transactionProducts.push({
                        'item_id': 'online_mock_exam_' + course.id,
                        'item_name': course.course.name,
                        'price': course.course.price.toString(),
                        'quantity': 1,
                        'item_category': 'Přijímačky nanečisto',
                        'item_category2': course.course.classLesson,
                        'item_variant': 'on-line'
                    });
                });
                coursesState.savedPersonalTests.forEach(course => {
                    transactionProducts.push({
                        'item_id': 'onsite_test_' + course.id,
                        'item_name': course.course,
                        'price': course.term.price.toString(),
                        'quantity': 1,
                        'item_category': 'Přijímačky nanečisto',
                        'item_category2': course.classLesson,
                        'item_variant': 'on-site'
                    });
                });

                pushDataLayer({ 'ecommerce': null });
                const purchaseEvent: any = {
                    'event': 'purchase',
                    'ecommerce': {
                        'transaction_id': Date.now().toString() + '_' + (Math.random() + 1).toString(36).substring(7),
                        'currency': 'CZK',
                        'value': (price ?? 0),
                        'tax': 0,
                        'shipping': 0,
                        'items': transactionProducts,
                    }
                };
                if (state.discount.one_time === 0 && state.discount.code) {
                    purchaseEvent.coupon = state.discount.code;
                }
                pushDataLayer(purchaseEvent);

                const redirectUrl = res?.data?.data?.redirect_url;
                const payments = res?.data?.data?.payments;
                if (redirectUrl && pay_by === 'PAYMENT_GATEWAY') {
                    sessionStore.set('onsite_courses', []);
                    sessionStore.set('online_courses', []);
                    sessionStore.set('online_mock_exam_courses', []);
                    sessionStore.set('onsite_tests', []);
                    window.location.replace(redirectUrl);
                } else if (payments && pay_by === 'BANK_TRANSFER') {
                    dispatch({ type: GlobalTypes.ToggleLoader });
                    dispatchCourses({ type: CoursesTypes.ResetSavedCourses });

                    dispatch({ type: GlobalTypes.ToggleModal });
                    dispatch({ type: GlobalTypes.ToggleModal, modal: 'ModalPaymentInfo', props: { payments: payments }});
                } else {
                    window.location.replace(routesURLs.dashboard);
                    dispatch({ type: GlobalTypes.ToggleLoader });
                    dispatchCourses({ type: CoursesTypes.ResetSavedCourses });
                }
            })
            .catch((error) => {
                dispatch({ type: GlobalTypes.ToggleLoader });
                dispatch({
                    type: GlobalTypes.ToggleNotification,
                    style: 'error',
                    text: error?.response?.data?.message,
                });
            });
    };

    const continueToOrder = (pay_by: PayByType) => {
        if (profile?.is_parent_password_set || coursesState.savedOnlineMockExamCourses.length === 0) {
            manageOrder(pay_by);
        } else {
            dispatch({
                type: GlobalTypes.ToggleModal,
                modal: 'ModalSetParentPassword',
                props: {
                    callback: () => manageOrder(pay_by),
                },
            });
        }
    };

    const buyButton = () => {
        if (!getCookie('jid')) {
            return (
                <>
                    <Button
                        color="primary"
                        disabled={true}
                    >
                        Dokončete registraci
                    </Button>
                </>
            );
        }

        return (
            <>
                {coursesInBasket > 0 && price !== 0 ? (
                    <ButtonDropdown
                        loading={!!state.loader}
                        options={(coursesState.savedOnlineCourses.length > 0 || coursesState.savedOnlineMockExamCourses.length > 0) ? [
                            { text: 'Zaplatit kartou on-line', action: () => continueToOrder('PAYMENT_GATEWAY') },
                            { text: 'Zaplatit převodem', action: () => continueToOrder('BANK_TRANSFER') },
                        ] : [
                            { text: 'Zaplatit převodem', action: () => continueToOrder('BANK_TRANSFER') },
                        ]}
                    >
                        Přejít k platbě
                    </ButtonDropdown>
                ) : (
                    <Button
                        color="primary"
                        onClick={() => continueToOrder('BANK_TRANSFER')}
                        loading={!!state.loader}
                    >
                        {price ? 'Přejít k platbě' : 'Získat kurz'}
                    </Button>
                )}
            </>
        );
    };

    if (coursesInBasket === 0) {
        return (
            <div className="modal-content h-background-body">
                <h1 className="h-text-center h-mb-175">Nákupní košík</h1>
                <div className="container-row">
                  Košík je prázdný.
                </div>
            </div>

        );
    } else {
        return (
            <div className="modal-content h-background-body">
                <h1 className="h-text-center h-mb-175">Nákupní košík</h1>
                <div className="container-row">
                    {coursesState.savedOnlineCourses.map((course) => (
                        <BasketItem
                            key={course.id}
                            course={course}
                            title={course.course.name}
                            price={course.course.price}
                            lessonCount={course.lesson_ids.length}
                            courseType="online"
                            removeCourse={removeCourse}
                        />
                    ))}

                    {coursesState.savedPersonalCourses.map((course) => (
                        <BasketItem
                            key={course.id}
                            course={course}
                            title={course.course}
                            price={course.term.price}
                            lessonCount={course.term.lessons_count}
                            courseType="personal"
                            removeCourse={removeCourse}
                        />
                    ))}

                    {coursesState.savedOnlineMockExamCourses.map((course) => (
                        <BasketItem
                            key={course.id}
                            course={course}
                            title={course.course.name}
                            price={course.course.price}
                            lessonCount={course.lesson_ids.length}
                            courseType="online-mock-exam"
                            removeCourse={removeCourse}
                        />
                    ))}

                    {coursesState.savedPersonalTests.map((course) => {
                        const parsed = parseISO(course.term.date_from);
                        const timeFrom = course.term.time_from ?? '';

                        if (timeFrom && /^\d{2}:\d{2}$/.test(timeFrom.trim())) {
                            const [hours, minutes] = timeFrom.split(':').map(Number);
                            parsed.setHours(hours);
                            parsed.setMinutes(minutes);
                        }

                        const formatted = format(parsed, timeFrom ? 'd. MMMM yyyy HH:mm' : 'd. MMMM yyyy', {
                            locale: cs,
                        });


                        return (
                            <BasketItem
                                key={course.id}
                                course={course}
                                title={`${course.course} (${formatted})`}
                                price={course.term.price}
                                lessonCount={0}
                                courseType="personalTest"
                                removeCourse={removeCourse}
                            />
                        );
                    })}
                </div>

                <p>Můžete používat až na 3 zařízeních.</p>

                <Button
                    color="outline"
                    onClick={() => removeAllItem()}
                    icon="bin-gray"
                    className="remove-all-item"
                >
                    Vysypat košík
                </Button>

                <hr />
                {!!coursesState.savedOnlineCourses.length && (
                    <>
                        <div className="h-py-05">
                            <DiscountCode />
                        </div>
                        <hr />
                    </>
                )}

                <div className="personal-courses-form-summary">
                    <div className="personal-courses-form-summary-price-wrapper">
                        <FinalPrice setPrice={setPrice} />
                    </div>

                    {buyButton()}
                </div>
            </div>
        );
    }
}

export default ModalBasket;
